
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as guTusjEUyxH18bT8_45JwWUdtzx_3Z7q8d0_4553UWaOhR8QMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexaEFIPH4sa6ANeVXmwFGnxSXLz5WRRqOZaz4X9BqzqugMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchIGSRahqx4rKJJu_g1tK871pXNZ89ZyxE_SOrryO6DJ0Meta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexq6y_4555ieBJBe9jIjbZP_XLLpLtMkADYHX0WyMY3p3gYMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_932Czh8SFGVO4jlblLFhFHgD7SNUrENCJzmjJBJbc_RkEMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexU_y9vXhzD_YFehF366vYRNCxhPVhvOHeVTCyHk5ANMEMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Z9buXDv1hc6cYvCBZVBjhpoyxNxiTWJ7Fge_45uTmQOUYMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexnnD9Kq2u4BZT5Rj_45bSoE67ZR8sV__lrrFG1vyybNx1sMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93i7vGv50hSLNEf6f4Y7JDyYmfqknJTwR7yJfumvOREpsMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index4OarOzNtuclbmfZWNtGuQyczREKUikLDRx2Jsywj1CIMeta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexN1_453jrC87oj9yGcCjrFlFk25ZKVqseCnaXRt9eI_V_450Meta } from "/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexU_y9vXhzD_YFehF366vYRNCxhPVhvOHeVTCyHk5ANMEMeta || {},
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexnnD9Kq2u4BZT5Rj_45bSoE67ZR8sV__lrrFG1vyybNx1sMeta || {},
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index4OarOzNtuclbmfZWNtGuQyczREKUikLDRx2Jsywj1CIMeta || {},
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexN1_453jrC87oj9yGcCjrFlFk25ZKVqseCnaXRt9eI_V_450Meta || {},
    component: () => import("/codebuild/output/src1869522312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]